// Remembers why the user was signed out behind their back (revoked session,
// archived organization...) so the welcome page can tell them after the redirect.
const FORCED_LOGOUT_KEY = 'forced_logout_reason';

export type ForcedLogoutReason = 'session_ended' | 'organization_archived';

export function markForcedLogout(code?: string): void {
    const reason: ForcedLogoutReason = code === 'ORGANIZATION_ARCHIVED' ? 'organization_archived' : 'session_ended';
    try {
        sessionStorage.setItem(FORCED_LOGOUT_KEY, reason);
    } catch {
        // Storage unavailable: the redirect still happens, without the message.
    }
}

export function readForcedLogout(): ForcedLogoutReason | null {
    try {
        const value = sessionStorage.getItem(FORCED_LOGOUT_KEY);
        return value === 'session_ended' || value === 'organization_archived' ? value : null;
    } catch {
        return null;
    }
}

export function clearForcedLogout(): void {
    try {
        sessionStorage.removeItem(FORCED_LOGOUT_KEY);
    } catch {
        // Nothing to clear.
    }
}
